import { getDocumentMeta } from 'remote-com-shared/domains/navigation/hrefResolver';

import { getSlicesContext } from '@/src/domains/prismic/helpers';
import {
  queryCountryBenefitsPage,
  queryAllCountryBenefitsPages,
  queryCountryBenefitsShared,
} from '@/src/views/CountryBenefits/services';

export { CountryBenefitsPage as default } from '@/src/views/CountryBenefits';

export async function getStaticProps({ params, previewData, locale }) {
  const { uid } = params;
  const data = await queryCountryBenefitsPage({ uid, previewData, locale });

  if (!data) {
    return { notFound: true };
  }

  const sharedData = await queryCountryBenefitsShared({ previewData, locale });

  const { country_name: countryName } = data;

  const body = await getSlicesContext(data.body, {
    benefits_hero_country_: async () => ({
      countryName,
    }),
    benefits_more_information: async () => ({
      countryName,
    }),
    benefits_table_3_column: async () => ({
      countryName,
    }),
    benefits_country_hiring: async () => ({
      countryName,
    }),
    link_to_pricing_table: async () => ({
      countryName,
    }),
  });

  return {
    props: {
      ...data,
      body,
      sharedData,
    },
  };
}

export async function getStaticPaths() {
  const countryBenefitsPagesList = await queryAllCountryBenefitsPages();
  return {
    paths:
      countryBenefitsPagesList?.map((document) => {
        const { uid, lang } = getDocumentMeta(document);
        return {
          params: { uid },
          locale: lang,
        };
      }) || [],
    fallback: false,
  };
}
